/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useRef, useEffect } from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import { AIAssistViewComponent } from '@syncfusion/ej2-react-interactive-chat';
import { useStateContext } from '../contexts/ContextProvider';
import { Button } from '.';
import '../pages/Zackat.css'; // Make sure to import your CSS file

const UserFAQ = ({ dt }) => {
  const usr = JSON.parse(localStorage.getItem('user'));
  const { REACT_APP_API_ENDPOINT } = process.env;
  const isFirstRender = useRef(true);

  const {
    aiType,
    patientid,
    handleClick,
    boss,
  } = useStateContext();
  const assistInstance = useRef(null);
  const [enableAssociate, setEnableAssociate] = useState(false);
  const [prompt, setPrompt] = useState('');
  const [promptResponse, setPromptResponse] = useState(null);
  const [airesponse, setAIResponse] = useState('');
  const [loading, setLoading] = useState(true);

  const promptSuggestions = [
    'Best practices for importing data?',
    'How do I assign inventory?',
  ];
  const [prompts, setPrompts] = useState(promptSuggestions);
  const [message, setMessage] = useState('');
  useEffect(() => {
    // Set a timeout to hide the alert
    const timer = setTimeout(() => {
      setMessage('');
    }, 2000);

    // Cleanup function to clear the timeout if the component unmounts
    return () => {
      clearTimeout(timer);
    };
  }, [message]); // Re-run effect if duration or onClose changes
  useEffect(() => {
    // fetch data
    const promptFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/faq?${query}&kbid=${aiType}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });

      // set state when the data received
      if (mydata && mydata.length > 0) {
        const loc = window.location;
        const path = loc.pathname.replaceAll('/', '');
        const q = `Show me more details on ${path}?`;
        if (!mydata.includes(q) && aiType !== 'Predictive Analysis') {
          mydata.push(q);
        }
        setPrompts(mydata);
      }
      setLoading(false);
    };
    promptFetch();
  }, []);
  useEffect(() => {
    // fetch data
    const promptInsert = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/faq?${query}&kbid=${aiType}`;
      try {
        const response = await (
          await fetch(url, {
            method: 'POST',
            body: JSON.stringify(promptResponse),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        );

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const mydata = await response.json()
          .catch((err) => {
            console.error('Error parsing JSON:', err);
            return null;
          });
        if (mydata && mydata.response === 'OK') {
          setMessage('thank you for your feedback');
        }
      } catch (error) {
        console.error('Error inserting data:', error);
      }
    };
    // Check if it's the first render
    if (isFirstRender.current) {
      isFirstRender.current = false; // Mark as not the first render for next time
      // Skip the effect's logic this time
    } else {
      promptInsert();
    }
  }, [promptResponse]);
  /*
  useEffect(() => {
    // limit associates to the overall selection
    // fetch data
    const promptFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/faq?${query}&kbid=${aiType}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      if (mydata && mydata.length > 0) {
        const loc = window.location;
        const path = loc.pathname.replaceAll('/', '');
        const q = `Show me more details on ${path}?`;
        if (!mydata.includes(q) && aiType !== 'Predictive Analysis') {
          mydata.push(q);
        }
        setPrompts(mydata);
      }
      setLoading(false);
    };
    promptFetch();
  }, []);
*/

  const onPromptRequest = async (args) => {
    // Access the user's prompt from args.promptText
    if (!args || !args.prompt || args.prompt === '') {
      assistInstance.current.addPromptResponse('Please enter a prompt and try again.');
      return;
    }
    const userPrompt = args.prompt;

    try {
      // Replace with your actual backend API endpoint
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const uri = `${REACT_APP_API_ENDPOINT}/faq?${query}`;
      let data = { question: userPrompt, kbid: aiType };
      if (enableAssociate) {
        data = { question: userPrompt, kbid: aiType, patientid };
      }
      const response = await fetch(uri, {
        method: 'PUT', // Or 'GET', depending on your backend
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const mydata = await response.json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      // Assuming your backend returns a JSON object with a 'response' field
      const backendResponse = mydata.answer;
      setAIResponse(backendResponse);
      // Add the backend's response to the AIAssistView
      assistInstance.current.addPromptResponse(backendResponse);
    } catch (error) {
      console.error('Error fetching data:', error);
      // Handle the error by adding an error message to the UI
      assistInstance.current.addPromptResponse('Sorry, something went wrong. Please try again.');
    }
  };

  useEffect(() => {
    const defaultResponse = 'For real-time prompt processing, connect the AI AssistView control to your preferred AI service, such as OpenAI or Azure Cognitive Services. Ensure you obtain the necessary API credentials to authenticate and enable seamless integration.';

    const fetchFaq = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const uri = `${REACT_APP_API_ENDPOINT}/faq?${query}`;
      const data = { question: prompt };
      try {
        const myfaq = await (
          await fetch(uri, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })).json();
        if (myfaq) {
          if (myfaq.answer) {
            assistInstance.current.addPromptResponse(myfaq.answer);
          } else {
            assistInstance.current.addPromptResponse(defaultResponse);
          }
        }
      } catch (error) {
        console.error('Fetch error:', error.message);
      }
    };
    if (prompt !== '') {
      fetchFaq();
    }
  }, [prompt]);

  const bannerTemplate = `<div class="banner-content">
    <div class="e-icons e-assistview-icon"></div>
        <h3>AI Assistance</h3>
        <i>To get started, provide input or choose a suggestion.</i>
    </div>`;
  // Handler for the "Copy" button click
  const handleCopy = (response) => {
    navigator.clipboard.writeText(response);
    setMessage('copied to clipboard...');
  };
  const toolbarClick = (args) => {
    handleClick('userFaq');
    setEnableAssociate(!enableAssociate);
    setTimeout(handleClick('userFaq'), 1000);
    // return { ...item, prefixIcon: 'e-icons e-italic-icon', tooltipText: 'Italic' }
  };
  const handleToolbarClick = (args) => {
    // The 'args' object contains information about the clicked item
    if (args.item.iconCss.includes('-like')) {
      // Add your custom logic here (e.g., send feedback to a server)
      if (aiType === 'Predictive Analysis') {
        const rsp = {
          prompt: assistInstance.current.properties.prompts[0].properties.prompt,
          response: assistInstance.current.properties.prompts[0].properties.response,
          collection: 'physio',
        };
        setPromptResponse(rsp);
      } else {
        setMessage('thank you for your feedback');
      }
    } else if (args.item.iconCss.includes('-dislike')) {
      setMessage('thank you for your feedback');
    } else if (args.item.iconCss.includes('-copy')) {
      handleCopy(airesponse);
    }
  };

  const responseToolbarSettings = {
    items: [
      { type: 'Button',
        iconCss: 'e-icons e-copy',
      },
      { type: 'Button',
        iconCss: 'e-icons e-assist-like',
      },
      { type: 'Button',
        iconCss: 'e-icons e-assist-dislike',
      },
    ],
    itemClicked: handleToolbarClick,
  };
  const toolbarSettings = {
    items: [
      {
        type: 'Input', // Set the item type to Input
        template: '<label htmlFor="bob">Include Associate Vitals</label><input id="bob" name="bob" type="checkbox" id="myCheckbox" />', // Define the input element in the template
        align: 'Right', // Optional: align to the right
      },
      // You can add other standard items like 'Bold', 'Italic', etc.
      'Bold',
      'Italic',
    ],
    itemClicked: toolbarClick,
  };

  return (
    <div
      className="nav-item absolute right-1 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96"
      id="faq"
      style={{
        height: '600px', /* A fixed height is often required for overflow to work correctly */
        width: '600px',
        overflowY: 'scroll', /* Always shows the scrollbar */
      }}
    >
      <div className="zackat-divalh">
        <div style={{ backgroundColor: '#F6821E' }}>
          {message}
        </div>
        <div className="flex justify-between items-center">
          <p className="font-semibold text-lg dark:text-gray-200 ml-20">{aiType}</p>
          <Button
            icon={<MdOutlineCancel />}
            color="rgb(153, 171, 180)"
            bgHoverColor="light-gray"
            size="2xl"
            borderRadius="50%"
          />
        </div>
        {/* Specifies the tag to render the AI AssistView component */}
        {!loading && (
        <div id="containerToolbar">
          {(aiType === 'Predictive Analysis' && (
          <ToolbarComponent id="toolbar" onClick={toolbarClick} overflowMode="MultiRow">
            <ItemsDirective>
              <ItemDirective text="Associate" float="left" tooltipText="Include Associate Vitals/Context" prefixIcon={enableAssociate ? 'e-circle-check' : 'e-circle'} visible={boss} />
              <ItemDirective type="Separator" />
            </ItemsDirective>
          </ToolbarComponent>
          )
        )}
          <AIAssistViewComponent
            id="aiAssistViewZ"
        // toolbarSettings={toolbarSettings}
            promptSuggestions={prompts}
            promptRequest={onPromptRequest}
            ref={assistInstance}
            bannerTemplate={bannerTemplate}
            responseToolbarSettings={responseToolbarSettings}
          />
        </div>
        )}
      </div>
    </div>
  );
};

export default UserFAQ;
